import React from 'react';
import logo from '../assets/instaship_logo.png';
import { BRAND_COLOR, BRAND_CONTRAST } from '../config/brand';

interface LogoProps {
  size?: number; // px
  bgColor?: string;
  showName?: boolean;
  name?: string;
  nameColor?: string;
  borderColor?: string;
  /** Scale of the inner image relative to the box size (0-1). Larger values make the PNG bigger inside the box. */
  imageScale?: number;
  /** Optional CSS box-shadow for the outer box */
  boxShadow?: string;
  /** Inner padding as fraction of box size (0-0.5). Defaults to 0.06 (6%). */
  innerPadding?: number;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 44, bgColor = BRAND_COLOR, showName = true, name = 'Instaship', nameColor = BRAND_CONTRAST, borderColor, imageScale, boxShadow, innerPadding = 0.06, className }) => {
  const scale = Math.min(1, Math.max(0.3, imageScale ?? 0.8));
  const paddingPx = Math.round(size * Math.min(0.5, Math.max(0, innerPadding)));
  const imgSizeBase = Math.round(size * scale);
  const imgSize = Math.max(1, imgSizeBase - paddingPx * 2);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }} className={className}>
      <div
        style={{
          width: size,
          height: size,
          borderRadius: 12,
          backgroundColor: bgColor,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: boxShadow ?? '0 6px 18px rgba(0,0,0,0.18)',
          border: borderColor ? `2px solid ${borderColor}` : undefined,
          padding: paddingPx,
        }}
        aria-hidden={false}
      >
        <img
          src={logo}
          alt={`${name} icon`}
          width={imgSize}
          height={imgSize}
          style={{ objectFit: 'contain', display: 'block' }}
        />
      </div>

      {showName && (
        <span style={{ color: nameColor, fontSize: '1.25rem', fontWeight: 700 }}>{name}</span>
      )}
    </div>
  );
};

export default Logo;
